<template>
  <div class="pc-items">
    <ul class="pc-items-list" v-if="payments.length">
      <pc-item v-for="payment in payments" :key="payment.id" :payment="payment" />
    </ul>
    <div class="ms-nodata ms-help" v-else>
      Платежи отсутствуют
    </div>
  </div>
</template>

<script>
import PcItem from './pc-item'

export default {
  props: {
    payments: {
      type: Array,
      required: true
    }
  },
  components: {
    PcItem
  }
}
</script>

<style lang="less">
.pc-items {
  max-height: 70vh;
  overflow: auto;
}
</style>
